export default {
  title: 'Apps',
  fields: {
    id: 'ID',
    name: 'Name',
    app_bundle_identifier: 'App Bundle ID',
    released: 'Veröffentlicht',
    franchise: 'Marke',
    app_icon: 'App-Symbol',
    status: 'Status',
    play_store_link: 'Play Store Link',
    apple_store_link: 'Apple Store Link',
    dynamic_link: 'Dynamic Link - QR Codes',
  },
  filters: {
    name: 'Name',
    released: 'Veröffentlicht',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Bereit zum Bauen',
    in_work: '🔧 In Arbeit',
    in_review: '📝 In Prüfung',
    rejected: '❌ Abgelehnt',
    released: '✅ Veröffentlicht',
    deactivated: '🛑 Deaktiviert',
  },
  card: {
    overdue: 'Überfällig · {{time}}',
    copied: 'In Zwischenablage kopiert',
    released_tag: {
      both: '✅ Veröffentlicht',
      ios: 'iOS Veröffentlicht',
      android: 'Android Veröffentlicht',
    },
    tags: {
      has_tech_issue: 'Technisches Problem',
    },
  },
  status_modal: {
    title: 'Release-Status aktualisieren',
    status_label: 'Status',
    note_label: 'Notiz (optional)',
    note_placeholder: 'Optional eine Notiz zu dieser Statusänderung hinzufügen',
    tech_issue_checkbox: 'Es liegt ein technisches Problem vor',
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
  released: {
    yes: 'Ja',
    no: 'Nein',
  },
  configured_status: {
    true: 'Ja',
    false: 'Nein',
  },
  delete_confirmation: {
    title: 'Mobile App löschen',
    message: 'Möchten Sie diese mobile App wirklich löschen?',
    buttons: {
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
    },
  },
};
